import React from 'react';
import { Grid } from '@lamimed/pantheon';

import { MarkdownContent } from 'components/MarkdownContent';

import * as S from './styles';

interface Props {
  markdown: string;
}

export const MainText: React.FC<Props> = ({ markdown }) => {
  return (
    <Grid.Wrapper>
      <S.Content>
        <MarkdownContent content={markdown} />
      </S.Content>
    </Grid.Wrapper>
  );
};
